import { primitives, semanticLight } from "@baton/tokens";
import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * The shadcn/ui `cn` helper the Spectrum UI sources import (2026-09-15, by the owner's
 * decision): clsx joins the classes and tailwind-merge drops the earlier of two classes in
 * the same group, so a caller's `className` overrides the component's own. tailwind-merge is
 * told the Baton theme keys `packages/tokens` emits beside Tailwind's own names, the type steps
 * and the elevations, because it would otherwise read `text-body` as a colour and keep both.
 * It reads the primitive and light semantic sets rather than the whole token tree, so the
 * chrome, dark and density sets stay out of the bundle.
 */
const typeSteps = Object.keys(primitives)
  .filter((name) => name.startsWith("text-") && name.endsWith("-size"))
  .map((name) => name.slice("text-".length, -"-size".length));

const elevations = Object.keys(semanticLight)
  .filter((name) => name.startsWith("elevation-"))
  .map((name) => name.slice("elevation-".length));

const merge = extendTailwindMerge({
  extend: {
    theme: {
      text: typeSteps,
      shadow: [...elevations, "kbd"],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return merge(clsx(inputs));
}
